import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const additionalServicesApi = createApi({
  reducerPath: "admin-additional-services",
  tagTypes: ["AdditionalServices"],
  baseQuery: createCustomFetchBaseQuery(),
  endpoints: (builder) => ({

    // ✅ Get all additional services
    getAllAdditionalServices: builder.query({
      query: ({ pageno, search ,sortOrder , sortBy , category, limit }) => {
        let url = `admin/additional-services?pageno=${pageno}`;

        if (search) {
          url += `&search=${encodeURIComponent(search)}`;
        }
        if(sortOrder){
          url += `&sortOrder=${sortOrder}`;
        }
        if(sortBy){
          url += `&sortBy=${sortBy}`;
        }
        if(category){
          url += `&category=${category}`;
        }
        if(limit){
          url += `&limit=${limit}`;
        }

        return {
          url,
          method: "GET",
        };
      },
      transformResponse: (res) => res,
      providesTags: ["AdditionalServices"],
    }),

    // ✅ Get single additional service by ID
    getAdditionalServiceById: builder.query({
      query: (id) => `admin/additional-service/${id}`,
      transformResponse: (res) => res?.body,
      providesTags: ["AdditionalServices"],
    }),

    // ✅ Add new additional service
    addNewAdditionalService: builder.mutation({
      query: (newService) => ({
        url: `admin/additional-service`,
        method: "POST",
        body: newService,
      }),
      invalidatesTags: ["AdditionalServices"],
    }),

    // ✅ Update additional service
    updateAdditionalService: builder.mutation({
      query: (updatedService) => ({
        url: `admin/additional-service/${updatedService.id}`,
        method: "PUT",
        body: updatedService,
      }),
      invalidatesTags: ["AdditionalServices"],
    }),

    // ✅ Delete additional service
    deleteAdditionalService: builder.mutation({
      query: (id) => ({
        url: `admin/additional-service/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["AdditionalServices"],
    }),

  }),
});

export const {
  useGetAllAdditionalServicesQuery,
  useGetAdditionalServiceByIdQuery,
  useAddNewAdditionalServiceMutation,
  useUpdateAdditionalServiceMutation,
  useDeleteAdditionalServiceMutation,
} = additionalServicesApi;
